import {util} from "zod"
import isInteger = util.isInteger;

const moneyFormats: any = {
    'en': 'EUR',
    'ck': 'EUR',
    'pt_PT': 'EUR',
    'pt': 'EUR',
    'es': 'EUR',
    'ca': 'EUR',
}

export const formatMoney = function (value: number,
                                     currencyCode?: string,
                                     locale?: string,
                                     subunitsValue: boolean = false,
                                     subunitsToUnit: number = 1,
                                     supplementalPrecision: number = 0): number | string {

    let result: number | string = ''

    if (Number.isFinite(value)) {
        try {

            if (!locale) {
                const {locale} = useI18n()
                currencyCode = currencyCode || moneyFormats[locale.value]
            }

            let numFormat: Intl.NumberFormat = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode
            })

            let options: Intl.ResolvedNumberFormatOptions = numFormat.resolvedOptions()
            let fraction_digits: number = options.minimumFractionDigits || 1

            if (subunitsToUnit > 1) {
                value = value / subunitsToUnit
            } else if (subunitsValue) {
                value = value / 10 ** fraction_digits
            }

            numFormat = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: isInteger(value) ? 0 : fraction_digits + supplementalPrecision,
                maximumFractionDigits: isInteger(value) ? 0 : fraction_digits + supplementalPrecision
            })
            result = numFormat.format(value)

        } catch (err: any) {
            console.error(err.message)
        }
    } else {
        result = '#NaN!'
    }

    return result
}
